<div class="cap-alerts-disclaimer">
  <h2 #heading class="cap-alerts-disclaimer__title" tabindex="-1">
    CAP Emergency Messaging Disclaimer
  </h2>

  <div class="cap-alerts-disclaimer__text">
    <p id="termsText">
      “Common Alerting Protocol Emergency Messaging” (“CAP Alerts”) is a system
      that allows the dissemination of emergency messages over a variety of
      public alerting systems.
    </p>
    <p id="termsText2">
      CAP Alerts is provided by independent third parties (“CAP Alerts
      Providers”) whom you select. You shall be solely responsible for ensuring
      the CAP Alerts service you select is configured, tested, and maintained to
      meet your needs. Neither Rise Vision nor hardware manufacturer of hardware
      products which include, display or otherwise utilize Rise Vision software,
      or distributors or resellers of Rise Vision software, are sellers of CAP
      Alerts and none provide any warranty or assume any liability for the
      performance, accuracy, or timely delivery of CAP Alerts, including
      connectivity failures, user configuration issues, or false, hacked,
      erroneous, missed, or delayed CAP Alerts.
    </p>
    <p id="termsText3">
      Rise Vision suggests that before implementing CAP Emergency Messaging you
      and/or your CAP Alerts Provider (a) connect to Rise Vision with the more
      secure HTTPS, not HTTP; (b) require an Authentication Name and Password
      for the connection; (c) ensure that your Displays have a stable internet
      connection for timely receipt of CAP Emergency Messaging; and (d) conduct
      periodic testing according to your own policies.
    </p>
  </div>

  <mat-checkbox
    id="termsAcceptedCheckbox"
    [checked]="termsAccepted()"
    [disabled]="disabled()"
    (change)="termsAccepted.set($event.checked)"
    >I accept this Disclaimer and Acknowledgement</mat-checkbox
  >

  <div class="cap-alerts-disclaimer__actions">
    <button
      rv-button
      variant="secondary"
      id="capAlertsDisclaimerCancelButton"
      type="button"
      [disabled]="busy()"
      (click)="cancelled.emit()"
    >
      Cancel
    </button>
    <button
      rv-button
      id="capAlertsDisclaimerAcceptButton"
      type="button"
      [disabled]="!canAccept()"
      [loading]="busy()"
      (click)="accept()"
    >
      Accept terms
    </button>
  </div>
</div>
